import setup from './moduleSetup';

export default {
    name: 'vendorRoutes',
    before: [],
    after: [],
    setup,
};
